import React from "react";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Select } from "components/inputs/select/Select";
import { TextInput } from "components/inputs/text-input/TextInput";
import { useClaimCheck } from "hooks/useClaimCheck";
import {
    CoreFilterOptions,
    FrameworkFilterOptions,
    SearchSortBarProps,
    SortOptions
} from "./types";

export const SearchSortBar = ({
    selectedSortOption = SortOptions.NewestFirst,
    handleSortChange,
    categoryOptions = [],
    selectedCategoryOption = "all",
    handleCategoryChange,
    hiddenSortOptions = [SortOptions.Next, SortOptions.Last],
    query,
    handleTextChange,
    showFilters = false,
    selectedFilterOption,
    setSelectedFilterOption,
    useCoreFilterOptions = false,
    onClear
}: SearchSortBarProps) => {
    const { t } = useTranslation("broadcasts-multi-select");
    const hasCatalogClaim = useClaimCheck("catalog");

    const filterOptions = useCoreFilterOptions
        ? CoreFilterOptions
        : FrameworkFilterOptions;

    return (
        <div className={`${styles["sort-search-container"]} search-sort-bar`}>
            <Select
                id="sort"
                onChange={(e) => {
                    handleSortChange(e.target.value as SortOptions);
                }}
                options={Object.keys(SortOptions)
                    .filter(
                        (option) =>
                            !hiddenSortOptions.includes(SortOptions[option])
                    )
                    .map((option) => {
                        return {
                            key: SortOptions[option],
                            label: t(SortOptions[option])
                        };
                    })}
                label="Sort"
                optionKey="key"
                optionLabel="label"
                selected={selectedSortOption}
                containerClassName={styles["sort-dropdown"]}
            />
            <Select
                id="category"
                onChange={(e) => {
                    handleCategoryChange(e.target.value);
                }}
                options={categoryOptions}
                selected={selectedCategoryOption}
                label={`${
                    hasCatalogClaim
                        ? t("broadcasts-multi-select:tag")
                        : t("broadcasts-multi-select:category")
                }`}
                containerClassName={styles["category-dropdown"]}
            />

            {showFilters && (
                <Select
                    id="filter"
                    onChange={(e) => {
                        setSelectedFilterOption(e.target.value);
                    }}
                    options={Object.keys(filterOptions).map((option) => {
                        let filterOption = filterOptions[option];
                        let label = filterOption;

                        switch (true) {
                            case filterOption === filterOptions.InPlayer &&
                                hasCatalogClaim:
                                label = "in-collection";
                                break;
                            case filterOption === filterOptions.NotInPlayer &&
                                hasCatalogClaim:
                                label = "not-in-collection";
                                break;
                            default:
                                label = filterOption;
                                break;
                        }

                        return {
                            key: filterOption,
                            label: t(label)
                        };
                    })}
                    selected={selectedFilterOption || filterOptions.All}
                    label="Filter"
                    optionKey="key"
                    optionLabel="label"
                    containerClassName={styles["filter-dropdown"]}
                />
            )}
            <div className={styles["search-bar-container"]}>
                <TextInput
                    id={"search"}
                    label={"Search"}
                    type={"text"}
                    onChange={(q) => {
                        handleTextChange(q.target.value);
                    }}
                    value={query}
                    className="broadcasts-search"
                    onClear={onClear}
                    hideClear={query === ""}
                />
            </div>
        </div>
    );
};
